import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Nav, Navbar, Container } from "react-bootstrap";
import Intro from "./routes/intro";
import CenterJang from "./routes/centerjang";
import School from "./routes/school";
import Wild from "./routes/wild";
import Yeongyeong from "./routes/yeongyeong";
import Yuhak from "./routes/yuhak";
import Main from "./routes/main";

function App() {
  return (
    <>
      <div style={{ maxWidth: "1200px", margin: "auto" }}>
        <Navbars />
        <div className="wrapper">
          <div className="contentWrapper">
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/centerjang" element={<CenterJang />} />
              <Route path="/intro" element={<Intro />} />
              <Route path="/school" element={<School />} />
              <Route path="/wild" element={<Wild />} />
              <Route path="/wild/yeongyeong" element={<Yeongyeong />} />
              <Route path="/wild/yuhak" element={<Yuhak />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

function Navbars() {
  let navigate = useNavigate();
  return (
    <Navbar style={{ backgroundColor: "white", color: "black" }}>
      <Container>
        <Navbar.Brand
          style={{ fontWeight: "bold" }}
          onClick={() => {
            navigate("/");
          }}
        >
          파워클라이밍
        </Navbar.Brand>
        <Nav className="me-auto">
          <Nav.Link
            onClick={() => {
              navigate("/intro");
            }}
          >
            이용안내
          </Nav.Link>

          <Nav.Link
            onClick={() => {
              navigate("/school");
            }}
          >
            파워스쿨
          </Nav.Link>
          <Nav.Link
            onClick={() => {
              navigate("/wild");
            }}
          >
            자연바위
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "white",
        color: "black",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <h4 style={{ fontWeight: "bold" }}>대구 파워 클라이밍 센터</h4>
      <h5>
        <span style={{ fontWeight: "bold" }}>센터장</span> 이정옥
      </h5>
      <h5>
        <span style={{ fontWeight: "bold" }}>주소</span> 대구 수성구
        달구벌대로467길 13, 3층, 대구파워클라이밍센터
      </h5>
      <h5>📞010-3892-8850</h5>
      <p>©Copyright 2021 - by.Bebsae</p>
    </footer>
  );
}

export default App;
